/* eslint-disable no-console */
//TODO: @Sara
import jwt_decode from 'jwt-decode';
import { decrypt } from '../../config/config.utils';
export class JwtClaims {
    static fromJWT(jwt) {
        const decoded = jwt_decode(jwt);
        const claims = new JwtClaims();
        claims.exp = decoded.exp;
        claims.email = decoded?.['email'];
        claims.emailVerified = decoded?.['email_verified'];
        claims.name = decoded?.['name'];
        claims.phoneNumber = decoded?.['phone_number'];
        claims.countryCode = decoded?.['country_code'];
        claims.preferredUsername = decoded?.['preferred_username'];
        claims.givenName = decoded?.['given_name'];
        claims.middleName = decoded?.['middle_name'];
        claims.familyName = decoded?.['family_name'];
        claims.customerId = decoded['sub'];
        claims.birth_year = decoded['birth_year'];
        claims.birth_month = decoded['birth_month'];
        claims.birth_day = decoded['birth_day'];
        claims.postal_code = decoded['postal_code'];
        claims.loginMethod = decoded['login_method'];
        claims.emailSubscription = decoded['comm_pref_email'];
        claims.phoneSubscription = decoded['comm_pref_phone'];
        return claims;
    }
}
export class TokenResponse {
    static fromFlatResponse(response) {
        const tokenResponse = new TokenResponse();
        const accessToken = decrypt(response['access_token']);
        tokenResponse.accessToken = {
            token: accessToken,
            expiresIn: response['expires_in'],
            claims: JwtClaims.fromJWT(accessToken),
        };
        const refreshToken = response['refresh_token'];
        tokenResponse.refreshToken = {
            token: refreshToken,
            expiresIn: response['refresh_expires_in'],
            claims: JwtClaims.fromJWT(decrypt(refreshToken)),
        };
        return tokenResponse;
    }
}
